<div class="container">
	<div class="left-sidebar">
		<fieldset style="width:400px">
			<legend>Configuration</legend>

			<div>
				<div class="setting-description">
					<label class="form-label">From date</label>
				</div>
				<div class="setting-field">
					<dx-date-box displayFormat="dd/MM/yyyy HH:mm" [value]="fromDate"></dx-date-box>
				</div>
			</div>

			<div>
				<div class="setting-description">
					<label class="form-label">To date</label>
				</div>
				<div class="setting-field">
					<dx-date-box displayFormat="dd/MM/yyyy HH:mm" [value]="toDate"></dx-date-box>
				</div>
			</div>


			<div *ngIf="queueStatusses$ | async as queueStatusses" style="padding-bottom: 20px;">
				<div class="setting-description">
					<label class="form-label">Queue status selector</label>
				</div>
				<dx-drop-down-box [inputAttr]="{ 'aria-label': 'Owner' }" placeholder="Select a value..."
					[showClearButton]="true" keyExpr="queueStatusString" displayExpr="queueStatusString"
					[dataSource]="queueStatusses" [(value)]="gridBoxValue">
					<div *dxTemplate="let data of 'content'">
						<dx-data-grid [dataSource]="queueStatusses" [selection]="{ mode: 'multiple' }"
							[hoverStateEnabled]="true" [columns]="['queueStatusString']"
							[paging]="{ enabled: true, pageSize: 10 }" [filterRow]="{ visible: true }"
							keyExpr="queueStatusString" [scrolling]="{ mode: 'virtual' }" [height]="345"
							[(selectedRowKeys)]="gridBoxValue">
						</dx-data-grid>
					</div>
				</dx-drop-down-box>
			</div>

			<div>
				<div style="padding-bottom: 40px;">
					<button style="float:right" class="btn btn-sm btn-primary add-button"
						(click)="requestData()">Retrieve data</button>
				</div>
			</div>
		</fieldset>
	</div>
</div>





<dx-data-grid id="gridContainer" [dataSource]="queueEntries$ | async" [showBorders]="true" [remoteOperations]="true">
	<dxo-paging [pageSize]="15"></dxo-paging>
	<dxi-column dataField="id" [width]=60></dxi-column>
	<dxi-column dataField="linkId" [width]=100></dxi-column>
	<dxi-column cellTemplate="queueTriggerStatusCellTemplate" dataField="trigger"></dxi-column>
	<dxi-column caption="Execution datetime (UTC)" dataField="executeAt" format="dd/MM/yyyy HH:mm"
		dataType="datetime"></dxi-column>
	<dxi-column caption="Time till execution" cellTemplate="timeDifferenceCellTemplate" format="dd/MM/yyyy HH:mm" dataType="datetime"></dxi-column>
	<dxi-column dataField="creationDate" [sortIndex]="1" sortOrder="desc" format="dd/MM/yyyy HH:mm" dataType="datetime"></dxi-column>
	<dxi-column cellTemplate="queueStatusCellTemplate" dataField="status"></dxi-column>
	<dxo-filter-panel [visible]="true"></dxo-filter-panel>
	<dxo-filter-builder [allowHierarchicalFields]="true">
	</dxo-filter-builder>
	<dxo-filter-builder-popup>
	</dxo-filter-builder-popup>
	<dxo-filter-row [visible]="true"></dxo-filter-row>
	<dxo-header-filter [visible]="true"></dxo-header-filter>

	<div *dxTemplate="let data of 'queueStatusCellTemplate'">
		<div>{{getEnumStringValueQueueStatus(data.data.status)}}</div>
	</div>
	<div *dxTemplate="let data of 'queueTriggerStatusCellTemplate'">
		<div>{{getEnumStringValueQueueTriggerStatus(data.data.trigger)}}</div>
	</div>
	<div *dxTemplate="let data of 'timeDifferenceCellTemplate'">
		<div>{{getTimeDifference(getUtcNow(),data.data.executeAt, data.data.status)}}</div>
	</div>

	<dxo-master-detail [enabled]="true" template="detailed"></dxo-master-detail>
	<div *dxTemplate="let queueEntry of 'detailed'">
		<app-shell-admin-queue-link-overview-detailed [queue]="queueEntry.data">
		</app-shell-admin-queue-link-overview-detailed>
	</div>

	<!-- <div *dxTemplate="let masterDetailItem of 'masterDetail'">
    <admin-queue-link-overview-detailed
      [key]="masterDetailItem"
      [rowData]="masterDetailItem"
    ></admin-queue-link-overview-detailed>
  </div> -->
</dx-data-grid>
